export interface BusinessHoursSettings {
  timezone: string;
  weekdays: number[];
  opensAt: string;
  closesAt: string;
}

export interface StoreSettingsProfile {
  settings: {
    businessHours: BusinessHoursSettings;
    reviewSlaMinutes: number;
  };
}

export interface StoreSettingsDraft {
  businessHours: BusinessHoursSettings;
  reviewSlaMinutes: number;
}

export function defaultBusinessHours(timezone = "UTC"): BusinessHoursSettings {
  return {
    timezone,
    weekdays: [1, 2, 3, 4, 5],
    opensAt: "09:00",
    closesAt: "17:00",
  };
}

export function defaultStoreSettingsDraft(): StoreSettingsDraft {
  return {
    businessHours: defaultBusinessHours(),
    reviewSlaMinutes: 240,
  };
}

export function draftFromProfile(profile: StoreSettingsProfile): StoreSettingsDraft {
  return {
    businessHours: profile.settings.businessHours,
    reviewSlaMinutes: profile.settings.reviewSlaMinutes,
  };
}

export function validateStoreSettingsDraft(draft: StoreSettingsDraft): string[] {
  return [
    validateBusinessHours(draft.businessHours),
    Number.isInteger(draft.reviewSlaMinutes) &&
    draft.reviewSlaMinutes >= 15 &&
    draft.reviewSlaMinutes <= 10_080
      ? undefined
      : "Review SLA must be between 15 minutes and 7 days.",
  ].filter((issue): issue is string => issue !== undefined);
}

function validateBusinessHours(value: BusinessHoursSettings): string | undefined {
  const validWeekdays = value.weekdays.every(
    (day) => Number.isInteger(day) && day >= 0 && day <= 6,
  );
  const validTimes =
    /^([01]\d|2[0-3]):[0-5]\d$/.test(value.opensAt) &&
    /^([01]\d|2[0-3]):[0-5]\d$/.test(value.closesAt);
  return validWeekdays && validTimes
    ? undefined
    : "Business hours must include valid weekdays and HH:mm times.";
}
